import { render, staticRenderFns } from "./MesaNewPedidos.vue?vue&type=template&id=06cf2a60&scoped=true"
import script from "./MesaNewPedidos.vue?vue&type=script&lang=js"
export * from "./MesaNewPedidos.vue?vue&type=script&lang=js"
import style0 from "./MesaNewPedidos.vue?vue&type=style&index=0&id=06cf2a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf2a60",
  null
  
)

export default component.exports